import { Card } from "primereact/card";
import { Avatar } from "primereact/avatar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
// import { Chip } from "primereact/chip";
import { useRef, useState } from "react";
import { Badge } from "primereact/badge";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import CandidateProfile from "./CandidateProfile";
import { Toast } from "primereact/toast";
import { Fetch } from "../../../shared/Fetch";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ILogin } from "../../../models/Login";
import { safeFormatDate } from "../../../models/DateFormatMapper";

interface FooterAction {
  onTagClick?: (candidate: any) => void;
  onEditClick?: (candidate: any) => void;
  onShareClick?: (candidate: any) => void;
  onMessageClick?: (candidate: any) => void;
  onViewClick?: (candidate: any) => void;
  // onPipelineClick?: (candidate: any) => void;
  loadingViewHistory: boolean;
  setLoadingViewHistory: (loadingViewHistory: boolean) => void;
  setUseageData: (usage: { customerId?: number; quota?: number; viewsConsumed?: number; viewsRemaining?: number }) => void;
  filters: any;
}

// ── Keyword Highlight Utility ─────────────────────────────────────────────────
const extractKeywords = (q: string): string[] => {
  if (!q) return [];
  return q
    .replace(/\(|\)/g, "")
    .split(/\s+AND\s+|\s+OR\s+|\s+NOT\s+/i)
    .map((k) => k.replace(/"/g, "").trim())
    .filter((k) => k.length > 1);
};

const HighlightText = ({ text, keywords }: { text: string; keywords: string[] }) => {
  if (!text || keywords.length === 0) return <>{text}</>;

  const escapedKeywords = keywords.map((k) => k.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  const regex = new RegExp(`(${escapedKeywords.join("|")})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, i) => {
        const isMatch = new RegExp(`^(${escapedKeywords.join("|")})$`, "gi").test(part);
        return isMatch ? (
          <mark
            key={i}
            style={{
              backgroundColor: "#fef08a",
              color: "#713f12",
              borderRadius: "2px",
              padding: "0 2px",
              fontWeight: 600,
            }}
          >
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </>
  );
};

export default function CandidateCard({ candidate, setUseageData, loadingViewHistory, setLoadingViewHistory, onTagClick, onEditClick, onShareClick, onMessageClick, onViewClick, filters }: any & FooterAction) {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const [starred, setStarred] = useState(candidate.isSaved ?? false);
  const [showCandidateModal, setShowCandidateModal] = useState({ open: false, singleData: {} } as { open: boolean; singleData: any });
  const [openViewHistory, setOpenViewHistory] = useState({ open: false, tableData: [] } as { open: boolean; tableData: { user_Name?: string; searched_On?: Date; company_Name?: string; branchName?: string }[] });
  const [viewAcces, setViewAcces] = useState({ isAccess: false, message: "" } as { isAccess: boolean; message?: string });
  const toast = useRef<any>(null);

  let _roles: Array<number> = [];
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  loginObj.roles.forEach((role) => {
    _roles.push(role.role_ID);
  });

  const initials = candidate.fullName
    ?.split(" ")
    .map((n: string) => n[0])
    .join("");

  const workplace = candidate.desiredWorkSettings?.join(", ");
  const keywords = extractKeywords(filters?.q ?? "");
  const hourlyRate = candidate.workPreferences?.[0]?.hourlyRate;
  const salary = candidate.workPreferences?.[0]?.annualSalary;

  const onPipelineClick = async () => {
    setLoadingViewHistory((prev: boolean) => (prev = true));
    const response = await Fetch("MassMail/getCandidateViewCount", "GET", null, `candId=${candidate.candidateId}`, toast);
    if (response) {
      const data: Array<{ user_Name?: string; searched_On?: Date; company_Name?: string; branchName?: string }> = await response.json();
      if (data.length > 0) {
        setOpenViewHistory({ open: true, tableData: data });
        setLoadingViewHistory((prev: boolean) => (prev = false));
      } else setLoadingViewHistory((prev: boolean) => (prev = false));
    } else setLoadingViewHistory((prev: boolean) => (prev = false));
  };

  const footerActions = [
    // {
    //   id: "view",
    //   icon: "pi pi-eye",
    //   tooltip: `${candidate.viewCount ?? 0} Profile Views`,
    //   count: candidate.viewCount ?? null,
    //   badgeSeverity: null,
    //   activeColor: "text-cyan-600",
    //   isToggle: false,
    //   isActive: false,
    //   onClick: () => onViewClick?.(candidate),
    // },
    {
      id: "pipeline",
      icon: "pi pi-users",
      tooltip: `${candidate.pipelineCount ?? 0} In Pipeline`,
      count: candidate.pipelineCount ?? null,
      badgeSeverity: null,
      activeColor: "text-cyan-600",
      isToggle: false,
      isActive: false,
      onClick: () => onPipelineClick(),
    },
    // {
    //   id: "tag",
    //   icon: "pi pi-tag",
    //   tooltip: candidate.tags?.length ? `Tags: ${candidate.tags.join(", ")}` : "No Tags Applied",
    //   count: candidate.tags?.length ?? null,
    //   badgeSeverity: null,
    //   activeColor: "text-orange-500",
    //   isToggle: false,
    //   isActive: false,
    //   onClick: () => onTagClick?.(candidate),
    // },
    // {
    //   id: "edit",
    //   icon: "pi pi-pencil",
    //   tooltip: candidate.hasNotes ? "Edit Notes" : "Add Notes",
    //   count: null,
    //   badgeSeverity: null,
    //   activeColor: "text-blue-500",
    //   isToggle: false,
    //   isActive: candidate.hasNotes ?? false,
    //   onClick: () => onEditClick?.(candidate),
    // },
    // {
    //   id: "share",
    //   icon: "pi pi-share-alt",
    //   tooltip: candidate.shareCount ? `Shared ${candidate.shareCount} times` : "Share Profile",
    //   count: candidate.shareCount ?? null,
    //   badgeSeverity: null,
    //   activeColor: "text-purple-500",
    //   isToggle: false,
    //   isActive: false,
    //   onClick: () => onShareClick?.(candidate),
    // },
    // {
    //   id: "message",
    //   icon: "pi pi-envelope",
    //   tooltip: candidate.unreadMessages ? `${candidate.unreadMessages} Unread Messages` : "Send Message",
    //   count: null,
    //   badge: candidate.unreadMessages > 0 ? candidate.unreadMessages : null,
    //   badgeSeverity: "danger",
    //   activeColor: "text-green-500",
    //   isToggle: false,
    //   isActive: false,
    //   onClick: () => onMessageClick?.(candidate),
    // },
    // {
    //   id: "star",
    //   icon: starred ? "pi pi-star-fill" : "pi pi-star",
    //   tooltip: starred ? "Remove from Saved" : "Save Candidate",
    //   count: null,
    //   badgeSeverity: null,
    //   activeColor: "text-yellow-500",
    //   isToggle: true,
    //   isActive: starred,
    //   onClick: () => setStarred((prev: boolean) => !prev),
    // },
  ];

  const DataFormat = loginObj.date_Format;

  const getViewAccess = async () => {
    const response = await Fetch("MassMail/getViewAccess", "GET", null, `profile_ID=${candidate.candidateId}`, toast);
    if (response) {
      const data: { isAccess: boolean; message?: string; maxViewsAllowed?: number; viewsConsumed?: number } = await response.json();
      const errorMessage = data?.message || "";
      if (data.isAccess === true) {
        setShowCandidateModal({ open: true, singleData: candidate });
        if (!_roles.includes(1) && data.maxViewsAllowed !== undefined && data.maxViewsAllowed !== null && data.maxViewsAllowed > 0)
          setUseageData({ customerId: 0, quota: data.maxViewsAllowed || 0, viewsConsumed: data.viewsConsumed || 0, viewsRemaining: (data.maxViewsAllowed || 0) - (data.viewsConsumed || 0) });
      } else toast.current.show({ severity: "error", summary: "Error", detail: errorMessage, life: 3000 });
    }
  };

  function getLastActiveLabel(dateString: string): string {
    const lastActiveDate = new Date(dateString);
    const today = new Date();

    // Normalize both dates to midnight
    lastActiveDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime: number = today.getTime() - lastActiveDate.getTime();
    const diffDays: number = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "Today";
    if (diffDays <= 30) return `${diffDays} Days Ago`;
    return "30+ Days Ago";
  }

  return (
    <>
      <Card className="p-4 mb-4 border-1 surface-border border-round-lg">
        {/* HEADER */}
        <div className="flex justify-content-between">
          <div className="flex gap-3">
            {/* <Checkbox /> */}

            {candidate !== null && candidate?.imageUrl !== undefined && candidate?.imageUrl !== null && candidate?.imageUrl?.trim() !== "" ? (
              <img style={{ width: "50px", height: "50px", borderRadius: "50%" }} src={candidate.imageUrl} alt="User Image" />
            ) : (
              <Avatar label={initials} shape="circle" size="large" className="bg-gray-300 text-black" />
            )}

            <div>
              <div className="text-xl font-semibold text-cyan-600 cursor-pointer" onClick={() => getViewAccess()}>
                <HighlightText text={candidate.fullName ?? ""} keywords={keywords} />
              </div>

              <div className="text-md text-purple-500 font-semibold">
                <HighlightText text={`${candidate.currentJobTitle ?? ""} at ${candidate.currentCompany ?? ""}`} keywords={keywords} />
              </div>

              <div className="text-sm text-500 font-bold text-black-alpha-90">
                <i className="pi pi-map-marker"></i> {candidate.city}, {candidate.region} • {candidate.yearsOfExperience} years experience • Active: {getLastActiveLabel(candidate.dateLastActive)}
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex flex-column align-items-end gap-2">
            <div className="flex gap-2">
              {/* <Button icon="pi pi-download" />
              <Button icon="pi pi-share-alt" />
              <Button icon="pi pi-ellipsis-h" /> */}
            </div>

            <div className="flex align-items-center gap-2 text-sm">
              {/* <span className="text-600">Dice Profile</span> */}
              {/* <img
              src="https://dmf1ol3sc7oaa.cloudfront.net/64/dice.png"
              width="20"
            /> */}
            </div>
          </div>
        </div>

        <Divider />

        {/* DETAILS */}
        <div className="grid text-sm">
          <div className="col-12 md:col-4 flex flex-column line-height-3 gap-3">
            <div>
              <b>Work Authorization:</b> {candidate.usCitizen ? "US Citizen" : candidate.workPermitDocuments?.join(", ")}
            </div>

            <div>
              <b>Willing to Relocate:</b> {candidate.workPreferences?.[0]?.willingToRelocate ? "Yes" : "No"}
            </div>

            <div>
              <b>Previous Title:</b> {candidate.currentJobTitle}
            </div>
          </div>

          <div className="col-12 md:col-4 flex flex-column line-height-3 gap-3">
            <div>
              <b>Workplace:</b> {workplace}
            </div>

            <div>
              <b>Salary:</b> ${salary?.min?.toLocaleString()} / yr | ${hourlyRate?.min}/hr
            </div>
          </div>

          <div className="col-12 md:col-4 flex flex-column line-height-3 gap-3">
            <div>
              <b>Likely to Switch:</b> {candidate.likelyToMove ? "Yes" : "Unknown"}
            </div>

            <div>
              <b>Profile Updated:</b> {getLastActiveLabel(candidate.dateLastUpdated)}
            </div>

            <div>
              <b>Resume Updated:</b> {getLastActiveLabel(candidate.dateResumeLastUpdated)}
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="font-semibold mb-3">Skills</div>

          <div className="grid">
            {(candidate.skills?.length > 6 && !showAllSkills ? candidate.skills.slice(0, 6) : candidate.skills).map((skill: any, index: number) => {
              const isMatched = keywords.some((kw) => skill.skill?.toLowerCase().includes(kw.toLowerCase()));
              return (
                <div key={index} className="col-12 md:col-4">
                  <div
                    className="flex justify-content-between align-items-center border-round p-2"
                    style={{
                      backgroundColor: isMatched ? "#fefce8" : "#f3f4f6",
                      border: isMatched ? "1px solid #fde047" : "1px solid transparent",
                    }}
                  >
                    <span>
                      <HighlightText text={skill.skill} keywords={keywords} />
                    </span>
                    <span className="text-sm text-600">{skill.yearsUsed} yrs</span>
                    <span className="text-sm text-600">{skill.lastUsed || 2026}</span>
                  </div>
                </div>
              );
            })}
          </div>
          {candidate.skills?.length > 6 && (
            <div className="flex justify-content-end mt-3 text-blue-600 cursor-pointer" onClick={() => setShowAllSkills(!showAllSkills)}>
              {showAllSkills ? "Show less skills" : "View all skills"}
              <i className="pi pi-angle-down ml-1"></i>
            </div>
          )}
        </div>

        <Divider />

        <div className="flex gap-4 align-items-center">
          {footerActions.map((action) => (
            <div key={action.id} className="relative">
              {/* <Tooltip target={`.icon-action-${action.id}`} content={action.tooltip} position="top" /> */}

              <div
                className={`icon-action-${action.id} flex align-items-center gap-1 cursor-pointer transition-colors transition-duration-200
                ${action.isActive || action.isToggle ? action.activeColor : "text-600 hover:" + action.activeColor}
              `}
                data-pr-tooltip={action.tooltip}
                onClick={() => {
                  if (loadingViewHistory === false) {
                    action.onClick();
                  }
                }}
              >
                <i className={loadingViewHistory === true ? "pi pi-spin pi-spinner" : action.icon} />

                {action.count != null && action.count > 0 && <span className="text-xs font-medium">{action.count}</span>}

                {/* {"badge" in action && action.badge && <Badge value={action.badge} severity={action.badgeSeverity as any} className="p-badge-sm" />} */}
              </div>
            </div>
          ))}
          {/* <div
            className={`flex align-items-center gap-1 cursor-pointer transition-colors transition-duration-200 ${starred ? "text-yellow-500" : "text-600"}`}
            data-pr-tooltip={starred ? "Remove from Saved" : "Save Candidate"}
            data-pr-position="top"
            onClick={() => setStarred((prev: boolean) => !prev)}
          >
            <i className={starred ? "pi pi-star-fill" : "pi pi-star"} />
          </div> */}
        </div>
      </Card>
      <Dialog header="Candidate Profile" visible={showCandidateModal.open} resizable style={{ width: "80vw" }} modal onHide={() => setShowCandidateModal({ open: false, singleData: {} })}>
        <CandidateProfile visible={showCandidateModal.open} singleData={showCandidateModal.singleData} toast={toast} filters={filters} />
      </Dialog>
      <Dialog header="Candidate View History" visible={openViewHistory.open} style={{ width: "50vw" }} modal onHide={() => setOpenViewHistory({ open: false, tableData: [] })}>
        <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" value={openViewHistory.tableData} emptyMessage="No Data found.">
          <Column field="user_Name" header="User Name" />
          <Column field="company_Name" header="Company" />
          <Column field="branchName" header="Branch" />
          <Column field="searched_On" header="Searched On" body={(rowData: any) => safeFormatDate(rowData.searched_On, "dd/MM/yyyy", DataFormat)} />
        </DataTable>
      </Dialog>
      <Toast ref={toast} />
    </>
  );
}
